import { useState, useRef, useEffect, useCallback } from 'react';

export function useResizablePanels() {
    const [dataFieldsWidth, setDataFieldsWidth] = useState(280);
    const [isResizingDataFields, setIsResizingDataFields] = useState(false);

    const workspaceRef = useRef(null);

    // ── Resizing Logic: Data Fields Sidebar ───────────────────────────────────
    const handleMouseDownDataFields = useCallback((e) => {
        e.preventDefault();
        setIsResizingDataFields(true);
    }, []);

    useEffect(() => {
        if (!isResizingDataFields) return;

        const handleMouseMove = (e) => {
            if (workspaceRef.current) {
                const workspaceRect = workspaceRef.current.getBoundingClientRect();
                const newWidth = Math.min(
                    Math.max(180, e.clientX - workspaceRect.left),
                    Math.min(550, workspaceRect.width * 0.55)
                );
                setDataFieldsWidth(newWidth);
            }
        };

        const handleMouseUp = () => {
            setIsResizingDataFields(false);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };

        document.body.style.cursor = 'col-resize';
        document.body.style.userSelect = 'none';

        window.addEventListener('mousemove', handleMouseMove);
        window.addEventListener('mouseup', handleMouseUp);

        return () => {
            window.removeEventListener('mousemove', handleMouseMove);
            window.removeEventListener('mouseup', handleMouseUp);
            document.body.style.cursor = '';
            document.body.style.userSelect = '';
        };
    }, [isResizingDataFields]);

    return {
        leftSidebarWidth: 0,
        dataFieldsWidth,
        isResizingLeft: false,
        isResizingDataFields,
        workspaceRef,
        handleMouseDownLeft: () => {},
        handleMouseDownDataFields
    };
}
